module.exports = __webpack_public_path__ + "img/120.08f49d21.jpg";